// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__360Zt","emails":"CreateEditClinics_emails__2AY02","emailTagLabel":"CreateEditClinics_emailTagLabel__2HDCh"};